// import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
// import { AgGridReact } from "ag-grid-react"
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-material.css';

// const PartnerMasterGrid = (props) => {
//     const gridRef = useRef()
//     const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
//     const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);


//     const columnDefs = [
//         {
//             headerName: 'Sr No.',
//             field: 'Id',
//             // flex: 1
//             width: 100
//         },
//         {
//             headerName: 'Partner Name',
//             field: 'sEntryPoint',
//             flex: 1
//         },
//     ]

//     return (
//         <div>
//             <div style={{
//                 height: "75vh",
//             }}>
//                 <div style={{ height: "100%", boxSizing: "border-box" }}>
//                     <div style={gridStyle} className="ag-theme-material" >
//                         <AgGridReact ref={gridRef}
//                             rowData={props.tableData || []}
//                             columnDefs={columnDefs}
//                             pagination={true}
//                             paginationPageSize={15}
//                         >
//                         </AgGridReact>
//                     </div>
//                 </div>
//             </div>

//         </div>
//     )
// }

// export default PartnerMasterGrid


// // NEW WORKING CODE AS MAKING CUSTOM SERIAL NUMBER AND SORTING ORDER DATA DISPLAY
// import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-material.css";

// const PartnerMasterGrid = (props) => {
//     const gridRef = useRef();
//     const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
//     const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

//     const columnDefs = [
//         {
//             headerName: 'Sr No.',
//             valueGetter: (params) => params.node.rowIndex + 1, // Calculate row index as serial number
//             width: 100,
//         },
//         {
//             headerName: 'Partner Name',
//             field: 'sEntryPoint',
//             flex: 1,
//         },
//     ];

//     return (
//         <div>
//             <div style={{ height: "75vh" }}>
//                 <div style={{ height: "100%", boxSizing: "border-box" }}>
//                     <div style={gridStyle} className="ag-theme-material">
//                         <AgGridReact
//                             ref={gridRef}
//                             rowData={props.tableData || []}
//                             columnDefs={columnDefs}
//                             pagination={true}
//                             paginationPageSize={15}
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PartnerMasterGrid;


// // NEW ALL WITH STORING CHECKED IN A VARIABLE- 
import React, { useMemo, useRef, useCallback, useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import Spinner from "../../common/Spinner/Spinner";

const PartnerMasterGrid = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%", backgroundColor:"" }), []);

    // const handleCheckboxChange = useCallback((event, data) => {
    //     props.setCheckedEntryPoints((prev) => {
    //         if (event.target.checked) {
    //             return [...prev, data];
    //         } else {
    //             return prev.filter((entry) => entry.Id !== data.Id);
    //         }
    //     });
    // }, []);

    const columnDefs = [
        // {
        //     headerName: "Select",
        //     field: "select",
        //     width: 100,
        //     cellRenderer: (params) => {
        //         return (
        //             <input
        //                 type="checkbox"
        //                 checked={props.checkedEntryPoints.some((entry) => entry.Id === params.data.Id)}
        //                 onChange={(event) => handleCheckboxChange(event, params.data)}
        //                 disabled={props.isAddClicked}
        //             />
        //         );
        //     },
        // },
        {
            headerName: "Sr No.",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 100,
        },
        {
            headerName: "Partner Name",
            field: "sEntryPoint",
            flex: 1,
        },
        // {
        //     headerName: "Validation Status",
        //     field: "valdiation status",
        //     width: 170,
        // },
    ];

    // console.log(props.checkedEntryPoints, ">>>.peopscheckedEntryPoints");
    return (
        <div className={`${props.loading && "set-opacity"}`}>
            <div style={{ height: "75vh", backgroundColor:"" }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material">
                        {props.loading && <Spinner className="center" />}
                        <AgGridReact
                            ref={gridRef}
                            rowData={props.tableData || []}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={20}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartnerMasterGrid;